import API from "../../../app/api";

export const getcategory = async () => {
  try {
    const res = await API.get("/banners");
    if (res.data?.success) {
      return res.data?.data?.category?.banners || [];
    }
    return [];
  } catch (error) {
    console.error("Category Error:", error);
    return [];
  }
};